import { Component } from "react";
import { DatePicker, Input, Select, Divider } from "antd";
import dayjs from "dayjs";
import { CalendarOutlined, FilterOutlined } from "@ant-design/icons";
import { withTranslation } from "react-i18next";
import { showToast } from "../../../utils";
// นำเข้า debounce
import debounce from "lodash.debounce";
import i18next from "i18next";
import localeTH from "antd/es/date-picker/locale/th_TH";
import localeEN from "antd/es/date-picker/locale/en_US";
const { RangePicker } = DatePicker;
const { Search } = Input;
const dateFormat = "YYYY-MM-DD";
export class SearchTransactions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      channel: "all",
      status: this.props.status || "all",
      // ตั้งค่า startDate เป็นเมื่อวาน
      startDate: dayjs().endOf("day"), //dayjs().subtract(1, "day").startOf("day"),
      // ตั้งค่า endDate เป็นวันนี้
      endDate: dayjs().endOf("day"),
      searchText: undefined,
      isMobile: window.innerWidth <= 768,
      typeSearch: "transRef",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleDateRangeChange = this.handleDateRangeChange.bind(this);
    this.handleSearchButtonClick = this.handleSearchButtonClick.bind(this);
    // สร้าง debounced function
    this.debouncedSearch = debounce(this.handleSearchButtonClick, 500);
  }
  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
    // ทำความสะอาด debounce เพื่อป้องกัน memory leaks
    this.debouncedSearch.cancel();
  }
  handleResize = () => {
    this.setState({ isMobile: window.innerWidth <= 768 });
  };
  getAntdLocale = () => {
    const currentLanguage = i18next.language;
    if (currentLanguage === "th" || currentLanguage === "lao") {
      return localeTH;
    }
    return localeEN;
  };
  scrollToAntSpinContainer() {
    const targetElement = document.querySelector(".ant-table-thead");

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      console.log('ไม่พบ Element ที่มี className "ant-table-thead"');
    }
  }

  handleChange = (key, value) => {
    this.setState({ [key]: value }, () => {
      this.debouncedSearch();
    });
  };

  handleDateRangeChange = async (dates) => {
    this.setState(
      {
        startDate: dates ? dates[0] : null,
        endDate: dates ? dates[1] : null,
      },
      () => {
        this.debouncedSearch();
      },
    );
  };

  handleSearchButtonClick = () => {
    const { onSearch, type, handleIsSearching } = this.props;
    const { startDate, endDate, searchText, typeSearch, status } = this.state;

    if (startDate && endDate && startDate.isAfter(endDate)) {
      showToast("error", this.props.t("Start date cannot be after end date."));
      return;
    }
    if (onSearch && handleIsSearching) {
      handleIsSearching(true);
      onSearch({
        status: status,
        startDate: startDate || "",
        endDate: endDate || "",
        searchText: searchText || "",
        type: type || "",
        typeSearch: typeSearch || "",
      });
    }
  };

  handleDisabled = (key) => {
    if (!key) return false;
    let locale = ["/user-activity"];
    return locale.includes(key);
  };
  onOk = async (dates) => { };
  handleDateRangeOkMobile = async (dates) => {
    const newStartDate = dates ? dates[0] : null;
    const newEndDate = dates ? dates[1] : null;

    if (!newStartDate && !newEndDate) {
      return;
    }
    // ใช้ handleDateRangeChange ซึ่งเรียก handleSearchButtonClick โดยตรง
    await this.handleDateRangeChange(dates);
  };
  handleOnSelect = async (e) => {
    if (!e) return null;
    this.setState({ typeSearch: e });
  };

  disabledDate = (current) => {
    if (!current) return false;

    // 1. ห้ามเลือกวันที่ในอนาคต (หลังจากวันนี้)
    const isAfterToday = current.isAfter(dayjs().endOf('day'));

    // 2. ห้ามเลือกวันที่เก่ากว่า 60 วันที่แล้ว
    const sixtyDaysAgo = dayjs().subtract(60, 'days').startOf('day');
    const isBefore60Days = current.isBefore(sixtyDaysAgo);

    return isAfterToday || isBefore60Days;
  };
  render() {
    const { type, activeKey1, t } = this.props;
    const { startDate, endDate, searchText, isMobile, typeSearch } = this.state;

    // ตั้งค่า Locale ภายใน Render เพื่อให้เปลี่ยนตาม i18next
    const antdLocale = this.getAntdLocale();
    const currentLanguage = i18next.language;
    dayjs.locale(currentLanguage === "lao" ? "lo" : currentLanguage);
    const options = [
      {
        value: "transRef",
        label: <>{t("transRef")}</>,
      },
      {
        value: "customerUuid",
        label: <>{t("Customer UUID")}</>,
      },
      {
        value: "senderName",
        label: <>{t("Sender Name")}</>,
      },
      {
        value: "senderAccountNo",
        label: <>{t("Sender AccountNo")}</>,
      },
    ];

    let SuffixIcon = <CalendarOutlined style={{ fontSize: "15px", marginRight: "5px", color: "rgb(90 90 90)" }} />;
    return (
      <div className="">
        <Divider orientation="left" className="mt-0">
          <span className="fs-sm-12" style={{ color: "#918f8f" }}><FilterOutlined /> {t("filters")}</span>
        </Divider>
        <div className="row row-sm">
          <div className="body w-100" style={{ margin: "5px 42px 0px" }}>
            <div className="row clearfix">
              <div className="col-lg-6 col-md-6">
                <div className="form-group">
                  <Select
                    id="dataTypeSelect"
                    style={{ width: "100%" }}
                    placeholder={t("Select Channel")}
                    defaultValue={t("Verify Slip")}
                    disabled={true}
                    value={type}
                    // onChange={(value) => this.handleChange("type", value)}
                    options={[
                      { label: t("Type : verifyslip"), value: "verifyslip" },
                    ]}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="form-group">
                  <Select
                    id="dataStatusSelect"
                    style={{ width: "100%" }}
                    placeholder={t("Select Status")}
                    defaultValue={t(`Status : ${this.state.status || "all"}`)}
                    onChange={(value) => this.handleChange("status", value)}
                    options={[
                      { label: t("Status : all"), value: "all" },
                      { label: t("Status : SUCCESS"), value: "SUCCESS" },
                      { label: t("Status : MATCHED"), value: "MATCHED" },
                      { label: t("Status : NOT_MATCH"), value: "NOT_MATCH" },
                      { label: t("Status : DUPLICATED"), value: "DUPLICATED" },
                    ]}
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-12">
                <div className="form-group">
                  <>
                    <RangePicker
                      prefix={SuffixIcon}
                      locale={antdLocale}
                      suffixIcon={SuffixIcon}
                      showTime={isMobile ? { format: "HH:mm" } : false}
                      disabledDate={this.disabledDate}
                      disabled={this.handleDisabled(activeKey1)}
                      format={dateFormat}
                      onOk={isMobile ? this.onOk : null}
                      className="w-100"
                      value={
                        startDate && endDate
                          ? [startDate, endDate]
                          : [null, null]
                      }
                      // ใช้ handleDateRangeChange ซึ่งเรียก handleSearchButtonClick โดยตรง
                      renderExtraFooter={() => {
                        return (<><span className="d-block text-danger fs-12 fs-sm-10">* {t("transaction_history_note")}</span></>)
                      }}
                      onChange={isMobile ? this.handleDateRangeOkMobile : this.handleDateRangeChange}
                    />
                  </>
                </div>
              </div>
              <div className="col-lg-6 col-md-12">
                <div className="form-group">
                  <Search
                    addonBefore={
                      this.handleDisabled(activeKey1) ? (
                        false
                      ) : (
                        <>
                          <Select
                            onChange={this.handleOnSelect}
                            options={options}
                            defaultValue={typeSearch}
                            prefix={<FilterOutlined />}
                            placeholder={t("filters")}

                          />
                        </>
                      )
                    }
                    allowClear
                    placeholder={this.handleDisabled(activeKey1) ? "Search" : t("search_by_type", { type: t(typeSearch) })}
                    value={searchText}
                    className="col-sm-100"
                    // การเปลี่ยนค่า searchText ถูกเรียกผ่าน this.handleChange -> debouncedSearch
                    onChange={(e) => this.handleChange("searchText", e.target.value)}
                    required
                    onSearch={() => searchText ? this.debouncedSearch() : {}} // เรียกการค้นหาเมื่อกดปุ่มค้นหา แต่ถ้า searchText ว่างจะไม่ทำอะไร
                    style={{ width: "100%", fontSize: "16px", background: "#fff" }}
                    enterButton
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(SearchTransactions);
